import Swiper from 'swiper';
import {
  Autoplay, EffectFade, Navigation, Pagination, Thumbs, Zoom,
// eslint-disable-next-line import/no-unresolved
} from 'swiper/modules';

export default class SwiperCarousel {
  /**
   * @param swiperEl {HTMLElement}
   * @param options {object}
   */
  constructor({ swiperEl, options = {} }) {
    this.dom = {
      swiper: swiperEl,
      navPrev: swiperEl.querySelector('.swiper-button-prev'),
      navNext: swiperEl.querySelector('.swiper-button-next'),
    };

    const defaultOptions = {
      modules: [Navigation, Pagination, EffectFade, Autoplay, Thumbs, Zoom],
      navigation: {
        prevEl: this.dom.navPrev,
        nextEl: this.dom.navNext,
      },
    };

    this.data = {
      options: { ...defaultOptions, ...options },
    };

    this.components = {
      swiperInstance: null,
    };
  }

  mount() {
    this.components.swiperInstance = new Swiper(this.dom.swiper, this.data.options);
    return this;
  }
}
